import { render, staticRenderFns } from "./orderDetail.vue?vue&type=template&id=63b8c908&scoped=true"
import script from "./orderDetail.vue?vue&type=script&lang=js"
export * from "./orderDetail.vue?vue&type=script&lang=js"
import style0 from "./orderDetail.vue?vue&type=style&index=0&id=63b8c908&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b8c908",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63b8c908')) {
      api.createRecord('63b8c908', component.options)
    } else {
      api.reload('63b8c908', component.options)
    }
    module.hot.accept("./orderDetail.vue?vue&type=template&id=63b8c908&scoped=true", function () {
      api.rerender('63b8c908', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/payment-link/components/tabs/orderDetail.vue"
export default component.exports